import { RefObject } from 'react'

export const getContentStyles = (
  alwaysOpen: boolean,
  isOpen: boolean,
  contentRef: RefObject<HTMLDivElement | null>,
) => {
  return {
    height: alwaysOpen
      ? 'auto'
      : isOpen
        ? `${contentRef?.current?.scrollHeight || 0}px`
        : '0px',
    transition: alwaysOpen
      ? 'none'
      : 'height 0.3s ease-in-out, padding 0.3s ease-in-out',
  }
}
